import clsx from 'clsx';
import { FormItemBase, IFormItemBaseProps } from 'copyright-clearance-center-common-ui-react';
import React, { useEffect, useRef, useState } from 'react';

export interface ITextareaProps extends IFormItemBaseProps {
	onChange: (value: string) => void;
	value?: string;
	placeholder?: string;
	testId?: string;
	maxLength?: number;
	rows?: number;
	fitContent?: boolean;
}

const Textarea: React.FunctionComponent<ITextareaProps> = props => {
	const ref = useRef<HTMLTextAreaElement>(null);
	const adjustedHeight = useRef('');
	const [userResized, setUserResized] = useState(false);

	const adjustHeight = () => {
		if (!ref.current || !props.fitContent || userResized) {
			return;
		}

		if (adjustedHeight.current && adjustedHeight.current !== ref.current.style.height) {
			setUserResized(true);
			return;
		}

		const style = window.getComputedStyle(ref.current);
		const borderTop = parseFloat(style.borderTopWidth);
		const borderBottom = parseFloat(style.borderBottomWidth);

		ref.current.style.height = `${ref.current.scrollHeight + borderTop + borderBottom}px`;
		adjustedHeight.current = ref.current.style.height;
	};

	useEffect(() => {
		adjustHeight();
	}, [props.value]);

	useEffect(() => {
		const observer = new ResizeObserver(adjustHeight);

		observer.observe(ref.current);
		return () => observer.disconnect();
	}, []);

	return (
		<FormItemBase {...props}>
			<textarea
				ref={ref}
				className={clsx('rup-input', {
					['rup-input--error']: props.error
				})}
				style={{ height: 'fit-content' }}
				maxLength={props.maxLength}
				placeholder={props.placeholder}
				disabled={props.disabled}
				value={props.value}
				rows={props.rows}
				onChange={e => {
					const newValue = e.target.value;
					props.onChange(newValue);
				}}
			/>
		</FormItemBase>
	);
};

export default Textarea;
